import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { LangContext } from 'browser/contexts/LangContext';

const ImageWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Image = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  object-fit: contain;
`;

const Label = styled.span`
  font-size: ${({ theme }) => theme.fontSize.md};
`;

const LoadedImage = ({ src, alt }) => {
  const { translate } = useContext(LangContext);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(false);
  }, [src]);

  return (
    <ImageWrapper>
      {isError ? (
        <Label>{translate('noPreview')}</Label>
      ) : (
        <Image onError={() => setIsError(true)} src={src} alt={alt} />
      )}
    </ImageWrapper>
  );
};

LoadedImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
};

LoadedImage.defaultProps = {
  src: '',
  alt: '',
};

export default LoadedImage;
